// This must be the first import for hot reloading to work
import 'expo-router/entry';
// animation package 'moti' requires we import these like this
import * as Sentry from '@sentry/react-native';
import { Platform } from 'react-native';
import 'react-native-gesture-handler';
import 'react-native-reanimated';
import 'react-native-url-polyfill/auto';

// Conditionally import registerGlobals and call it only on native
if (Platform.OS !== 'web') {
  // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-var-requires,@typescript-eslint/no-unsafe-assignment
  const { registerGlobals } = require('@livekit/react-native');
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  registerGlobals();
}

Sentry.init({
  dsn: 'https://da6a9868cf60d1cbd87baf9699d00775@o4508515692576768.ingest.us.sentry.io/4508515695788032',
  debug: __DEV__ ? true : false, // Enable debug in development to see Debug ID information
  tracesSampleRate: 1.0, // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing. Adjusting this value in production.
  integrations: [
    // Enable native crash reporting for better stack traces
    Sentry.reactNativeTracingIntegration({
      enableNativeFramesTracking: true,
      enableStallTracking: true,
    }),
  ],
  sendDefaultPii: true,
  // Enable source map resolution
  enableAutoSessionTracking: true,
  enableNativeCrashHandling: true,
});
